module.exports = __webpack_public_path__ + "static/media/rotate-right.3151556a.svg";